<template>
  <div class="fill-height overflow-hidden">
    <vue-headful :title="pageTitle"/>
    <embed class="embed" :src="$route.query.link" type="application/pdf"/>
  </div>
</template>

<script>
import SettingsService from '@/services/SettingsService'

export default {
  computed: {
    pageTitle () {
      return SettingsService.pageTitle('Просмотр PDF')
    }
  }
}
</script>

<style>
html, body {
  height: 100%;
  min-height: 100%;
}

.embed {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/pdf/View.vue